import styled from 'styled-components'

export const PopupOverlayOverflowHiddenUi = styled.div`
  overflow: hidden;
`
